// @flow
import React, { Component } from 'react';
//types
import { type PartnerDetail } from '../types';
import { ActionRowTr } from '../../../../components/ModelListStyles';
import { formatCurrency } from '../../../../utilities/numberFormatting';
import { type Currencies } from '../../../../utilities/types';
import { Device, Mobile } from '../../../../components/Responsive';
import { ExpandedRowTd, ExpandedRowDiv } from './ShowStyles';
import { CustomSpacerTd } from '../../../../modules/CrudTable/components/TableComponentStyles';

type Props = {
  colSpan: number,
  data: PartnerDetail,
  currencies: Currencies
};

export default class PartnersTableRowExpanded extends Component<Props> {
  render() {
    return (
      <ActionRowTr>
        <CustomSpacerTd />
        <td colSpan={this.props.colSpan}>
          <ExpandedRowDiv>
            <table>
              <tbody>
                <tr>
                  <td>
                    <h6>Transaction ID:</h6>
                  </td>
                  <ExpandedRowTd>{this.props.data.id}</ExpandedRowTd>
                </tr>
                <tr>
                  <Mobile>
                    <td>
                      <h6>Processing Vol:</h6>
                    </td>
                    <ExpandedRowTd>
                      {formatCurrency(
                        this.props.data.transaction_amount_sum,
                        this.props.currencies[this.props.data.currency]
                      )}
                    </ExpandedRowTd>
                  </Mobile>
                </tr>
                <tr>
                  <Device>
                    <td>
                      <h6>Transaction Fee:</h6>
                    </td>
                    <ExpandedRowTd>
                      {formatCurrency(
                        this.props.data.transaction_fee_sum,
                        this.props.currencies[this.props.data.currency]
                      )}
                    </ExpandedRowTd>
                  </Device>
                </tr>
                <tr>
                  <Mobile>
                    <td>
                      <h6># Merchants:</h6>
                    </td>
                    <ExpandedRowTd>
                      {this.props.data.merchant_count}
                    </ExpandedRowTd>
                  </Mobile>
                </tr>
              </tbody>
            </table>
          </ExpandedRowDiv>
        </td>
        <CustomSpacerTd />
      </ActionRowTr>
    );
  }
}
